import React, { useState, useEffect, useRef } from "react";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import {
  BsCameraVideoOffFill,
  BsMicMute,
  BsMicMuteFill,
  BsFillCameraVideoFill,
} from "react-icons/bs";
import { Switch } from "@headlessui/react";
import Webcam from "react-webcam";
import { TbWorld } from "react-icons/tb";

import like from "../../assets/images/icons/like.png";
import { FaSearch } from "react-icons/fa";
import { IoBagHandle } from "react-icons/io5";

const BuySellerView = () => {
  const [cameraOn, setCameraOn] = useState(false);
  const [micOn, setMicOn] = useState(false);
  const [commentsEnabled, setCommentsEnabled] = useState(false);
  const webcamRef = useRef(null);

  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  console.log(webcamRef);
  console.log(deviceId);

  const [isLive, setIsLive] = useState(false); // Tracks Go Live state

  const [chatMessages, setChatMessages] = useState([]);

  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

  const comments = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
  ];

  const products = [
    {
      id: 1,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png", // or a real image URL
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "8",
      color: "White/Blue",
    },
    {
      id: 2,
      name: "Nyawoo Sports Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 160,
      discountedPrice: 120,
      quantity: 1,
      size: "9",
      color: "Black/Red",
    },
  ];
  return (
    <div className="fixed inset-0 w-screen h-screen m-0 p-3 rounded-lg">
      <div className="w-full h-full relative bg-black flex items-center justify-center">
        {/* If camera is ON, show video stream */}
        {cameraOn ? (
          <div>
            <Webcam
              ref={webcamRef}
              audio={false}
              videoConstraints={{ deviceId: devices.deviceId }}
              className="absolute top-0 left-0 w-full h-full object-cover rounded-none"
            />

            <div className="absolute bottom-0 right-0 px-5  py-2 rounded-br-3xl flex gap-3 items-center">
              <div className="golive-chatbox p-4 mb-5  h-[550px] rounded-lg relative">
                <div className="absolute top-0 right-0 w-full h-[50%]  rounded-lg z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

                <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
                  {/* White Shade Blur Effect */}

                  {liveChatMessages.map((chat) => (
                    <div key={chat.id} className="px-3 py-1 rounded-md">
                      <div className="flex">
                        <div>
                          <img
                            src="/image/profilepic.png"
                            alt={chat.name}
                            className="w-9 rounded-full"
                          />
                        </div>
                        <div className="pl-2">
                          <p className="font-semibold">{chat.name}</p>
                          <p className="text-[8px] text-[#000000]">
                            {chat.time}
                          </p>
                        </div>
                      </div>
                      <p className="text-[12px] break-words pt-2">
                        {chat.message}
                      </p>
                      <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />
                    </div>
                  ))}
                </div>
                {/* Add Comment Input */}
                <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
                  <div className="relative flex flex-1 min-w-0 mx-2">
                    <input
                      type="text"
                      placeholder="Add a comment"
                      className="flex-1 min-w-0 p-3 border border-gray-300 rounded-full focus:outline-none"
                    />
                    <button className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                      Send
                    </button>
                  </div>
                  {/* Show Like Button only when live */}
                  {isLive && (
                    <button className="shrink-0 bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                      <img src={like} alt="Like" />
                    </button>
                  )}
                </div>
                {/* Footer */}
                <div className="lg:hidden">
                  <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                    © 2025 Nyawoo. All Rights Reserved
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute bottom-0 left-0 px-5  py-2 rounded-br-3xl flex gap-3 items-center">
              {products.map((product) => (
                <div
                  key={product.id}
                  className="flex justify-between items-center border rounded-xl p-4 bg-[#D9D9D9CC]"
                >
                  {/* Product Image */}
                  <div className="flex items-center gap-4">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-20 h-20 object-contain"
                    />
                    <div>
                      <h3 className="text-sm font-semibold">{product.name}</h3>
                      <div className="flex justify-between items-center">
                        <p className="text-[15px] font-bold text-[#095228]">
                          ${product.discountedPrice}{" "}
                        </p>{" "}
                        <button className="flex gap-2 items-center bg-[#095228] text-white rounded-xl text-xs mt-2 p-2">
                          <IoBagHandle className="text-lg" />
                          <span>Add to card</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <>
            {/* Overlay content */}
            <div className="absolute top-0 left-0 px-5 bg-[#D9D9D980] py-2 rounded-br-3xl flex gap-3 items-center">
              <div className="bg-white p-2 w-[50px] h-[50px] rounded-full">
                <img
                  src="/image/wanchain.png"
                  alt="logo"
                  className="w-[40px] h-[40px] object-contain"
                />
              </div>
              <div className="text-black">
                <p className="font-semibold text-xl">SKY Products</p>
                <p className="text-md">27 Jan 2025, 12:30 PM</p>
              </div>
            </div>

            <div className="flex flex-col justify-center items-center text-white h-full absolute top-0 left-0 w-full">
              <div className="text-4xl mb-4">
                <BsCameraVideoOffFill />
              </div>
              <p className="text-lg font-semibold">Allow Access To Camera</p>
              <p className="text-sm text-gray-400 text-center max-w-md mt-2 px-4">
                Your browser is not allowing Live Producer access to your
                camera. Go to your browser settings and allow camera permission.
              </p>
              <button
                onClick={() => {
                  setCameraOn((prev) => !prev);
                  const videoEl = webcamRef.current?.video;
                  if (videoEl && videoEl.srcObject) {
                    const stream = videoEl.srcObject;
                    const tracks = stream.getTracks();
                    tracks.forEach((track) => track.stop());
                  }
                }}
                className="mt-4 bg-gray-300 px-4 py-2 rounded"
              >
                on
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default BuySellerView;
